import { useTranslation } from "react-i18next";

import { useBlogArticleSelectors } from "../../../../../store/blogArticle/blogArticle.selectors";

import { useMainContentLogic } from "../../../../../hooks";

import { FaqAccordion } from "../../../../../components";
import ArticleNavigation from "../../../../../components/common/ArticleNavigation";
import { ArticleHeading } from "../ArticleHeading/ArticleHeading";
import { ArticleSubHead } from "../ArticleSubHead/ArticleSubHead";
import { addStyles } from "./addStyles";

import {
  ArticleWrapper,
  BlogSection,
  Wrapper,
  WrapperRoot,
} from "./MainContent.styled";

export const MainContent = () => {
  const { t } = useTranslation();
  useMainContentLogic();

  const { data } = useBlogArticleSelectors();

  return (
    <>
      <ArticleHeading
        main
        title={data?.title}
        tab={data?.tab}
        date={data?.createdDate}
      />

      {data?.anchors?.length > 1 && (
        <ArticleWrapper>
          <ArticleNavigation anchors={data?.anchors} />
        </ArticleWrapper>
      )}

      <WrapperRoot>
        <Wrapper>
          <BlogSection dangerouslySetInnerHTML={{ __html: data?.text }} />

          {data?.faqs?.length > 0 && (
            <>
              <ArticleSubHead
                title={t("blog.faq.title")}
                addStyles={addStyles.subHead}
              />
              <FaqAccordion faqData={data?.faqs} />
            </>
          )}
        </Wrapper>
      </WrapperRoot>
    </>
  );
};
